import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { BeneficiariesService } from '../shared/services/beneficiaries.service';
import { ToastService } from '../shared/toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaryGuard {
  constructor(
    private readonly router: Router,
    private readonly beneficiariesService: BeneficiariesService,
    private readonly toastService: ToastService,
  ) {}

  public async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let authorized: boolean = false;
    if (next.paramMap.has('id')) {
      const beneficiaryId: number = +next.paramMap.get('id');
      authorized = isNaN(beneficiaryId) ? false : beneficiaryId === 0 ? false : await this.beneficiariesService.isAuthorized(beneficiaryId);

      if (!authorized) {
        this.toastService.show("Vous n'avez pas l'autorisation d'accéder à cette page ou à cette ressource.", 'danger');
        this.router.navigate(['/beneficiaries']);
      }
    } else if (next.routeConfig.path === 'new') {
      authorized = true;
    }
    return authorized;
  }
}
